import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { EmailSuppression } from '../common/models/EmailSuppression.ts';
import { Box, Chip, Tooltip } from '@mui/material';
import { Formatter } from 'dg-web-shared/lib/Date.ts';
import { DateTime } from 'luxon';
import { Block } from '@mui/icons-material';

export function EmailSuppressionTag({
    suppression,
    tooltipPlacement = 'top',
}: {
    suppression: EmailSuppression | null;
    tooltipPlacement?: 'top' | 'right';
}) {
    if (!suppression) {
        return null;
    }
    return (
        <Box sx={{ '&&': { marginTop: 1 } }}>
            <Tooltip
                title={
                    <>
                        <SuppressionReason
                            reason={suppression.suppressionReason}
                        />{' '}
                        ·{' '}
                        <Localized de="seit" fr="depuis" it="dal" en="since" />{' '}
                        {Formatter.dayMonthYear(
                            DateTime.fromISO(suppression.suppressedAt),
                        )}
                    </>
                }
                placement={tooltipPlacement}
            >
                <Chip
                    sx={theme => ({
                        backgroundColor: theme.palette.error.main,
                        color: theme.palette.common.white,
                        textTransform: 'none',
                        ':hover': { backgroundColor: theme.palette.error.main },
                    })}
                    color="error"
                    size="small"
                    icon={<Block />}
                    label={
                        <Localized
                            de="Versand blockiert"
                            fr="Envoi bloqué"
                            it="Invio bloccato"
                            en="Sending blocked"
                        />
                    }
                />
            </Tooltip>
        </Box>
    );
}
function SuppressionReason({ reason }: { reason: string }) {
    switch (reason) {
        case 'HardBounce':
            return (
                <Localized
                    de="Hard Bounce (unzustellbar)"
                    fr="Hard bounce (non distribuable)"
                    it="Hard bounce (non recapitabile)"
                    en="Hard bounce (undeliverable)"
                />
            );
        case 'SpamComplaint':
            return (
                <Localized
                    de="Spam-Beschwerde"
                    fr="Plainte pour spam"
                    it="Segnalazione spam"
                    en="Spam complaint"
                />
            );
        case 'ManualSuppression':
            return (
                <Localized
                    de="Manuell gesperrt"
                    fr="Bloqué manuellement"
                    it="Bloccato manualmente"
                    en="Manually suppressed"
                />
            );
        default:
            return <>{reason}</>;
    }
}
